"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultRootPriceListState = void 0;
var RootPublicPageState_init_1 = require("@/pages/common/states/RootPublicPageState.init");
exports.defaultRootPriceListState = __assign(__assign({}, RootPublicPageState_init_1.defaultRootPublicPageState), { breadcrumb: {
        breadcrumbList: [
            { name: 'Home', link: '/' },
            { name: 'New Developements', link: '/new-developments' },
            { name: 'Park Mediterranean', link: '/new-development/park-mediterranean' },
        ],
        tFormat: {
            homePage: 'Home',
        },
    } });
